module.exports = __webpack_public_path__ + "img/head_icon_p3.70d35a48.png";